import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2AlertOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" data-name="Artwork" viewBox="0 0 32 32" width="1em" height="1em"><path d="M27.206 28H2.35L16 1.838 27.563 24h-2.256L16 6.162 5.65 26h22.956zM15 20h2v-9h-2zm0 4h2v-2h-2z" /></svg>
);
